import { render, staticRenderFns } from "./UpdateHealthCareProviderModal.vue?vue&type=template&id=4931f9a8"
import script from "./UpdateHealthCareProviderModal.vue?vue&type=script&lang=ts"
export * from "./UpdateHealthCareProviderModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports